import { useEffect, useRef, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import RoleSection from '../../components/features/rolesAndPermission/RoleSection.jsx';
import style from "../../assets/styles/roleAndPermission.module.scss";
import RoleUserView from "../../components/features/rolesAndPermission/RoleUserView.jsx";
import { updateSettingsCamp } from "../../redux/settingsSlice.js";
import PermissionSection from '../../components/features/rolesAndPermission/PermissionSection.jsx';
import PermissionRolesView from '../../components/features/rolesAndPermission/PermissionRolesView.jsx';
import {
  usePermissionsData,
  useCampaignData,
} from "../../hooks/rolesAndPermission";

export default function RolesAndPermissionPage() {
  const {
    control,
    watch,
    formState: { errors },
    setValue,
  } = useForm({});
  
  const dispatch = useDispatch();

  const [viewStates, setViewStates] = useState({
    showRoleUserView: false,
    showPermissionRolesView: false,
    selectedRole: null,
    editPermissionData: null,
  });

  const permissionsData = usePermissionsData();
  const { fetchOrganizations, campaigns } = useCampaignData(setValue);

  const campaignValue = watch("campaign");
  const previousCampaignRef = useRef(null);
  const isInitialMount = useRef(true);

  useEffect(() => {
    fetchOrganizations();
  }, [fetchOrganizations]);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      if (!campaignValue) return;
    }

    if (campaignValue && previousCampaignRef.current !== campaignValue) {
      previousCampaignRef.current = campaignValue;
      
      const camp = campaigns?.find((item) => item?.value === campaignValue);
      if (camp) {
        dispatch(updateSettingsCamp(camp));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignValue]);



  const updateViewStates = useCallback((updates) => {
    setViewStates((prev) => ({ ...prev, ...updates }));
  }, []);

  if (viewStates.showRoleUserView) {
    return (
      <div>
        <RoleUserView
          selectedRole={viewStates.selectedRole}
          backButton={() => updateViewStates({ showRoleUserView: false, selectedRole: null })}
          page={"role"}
        />
      </div>
    );
  }

  if (viewStates.showPermissionRolesView && viewStates.editPermissionData) {
    return (
      <PermissionRolesView
        editPermission={viewStates.editPermissionData}
        onBack={() => {
          updateViewStates({ showPermissionRolesView: false, editPermissionData: null });
        }}
        permissionsData={permissionsData}
      />
    );
  }

  return (
    <div className={style.rolescontainer}>
      <div className="">
        <RoleSection
          formProps={{ control, errors, setValue }}
          campaigns={campaigns}
          style={style}
          fetchPermissionsTable={permissionsData.fetchPermissionsTable}
          campaignValue={campaignValue}
          updateViewStates={updateViewStates}
        />
        
        <PermissionSection
          permissionsData={permissionsData}
          campaignValue={campaignValue}
          onEditPermission={(data) => {
            updateViewStates({ editPermissionData: data, showPermissionRolesView: true });
          }}
        />

      </div>
    </div>
  );
}
